import { createFileRoute } from "@tanstack/react-router";
import { SolicitudesPanel } from "@/components/admin/SolicitudesPanel";
import { paginationValidator } from "@/hooks/use-table-pagination";

export const Route = createFileRoute("/admin/solicitudes")({
  validateSearch: paginationValidator,
  component: SolicitudesPanel,
});
